import {useEffect, useState} from "react";
import isNull from "../mixin/isNull";
import Box from "@mui/material/Box";
import {Alert, Link, ListItemText} from "@mui/material";
import List from "@mui/material/List";

/**
 * @rule-checker exclude
 * @param param0
 * @param param0.children
 * @returns {*|JSX.Element|null}
 */
export default function ({children}) {
    const [localStorageAllowed, setLocalStorageAllowed] = useState(null);


    useEffect(() => {
        try {
            window.localStorage.getItem("check-permission");
            setLocalStorageAllowed(true);
        } catch (error) {
            setLocalStorageAllowed(false);
        }
    }, []);

    if (isNull(localStorageAllowed)) return null;

    if (!localStorageAllowed) {
        return (
            <Box mt={5}>
                <Alert severity={"error"}>
                    Vous devez autoriser les cookies pour utiliser cette application
                </Alert>

                <Box px={2} mt={5}>
                    <List>
                        <ListItemText>
                            Rendez vous dans "Réglages"
                        </ListItemText>
                        <ListItemText>
                            Parametres de Safari
                        </ListItemText>
                        <ListItemText>
                            Tout en bas, cliquez sur "Avancé"
                        </ListItemText>
                        <ListItemText>
                            Décochez "Bloquez tous les cookies"
                        </ListItemText>
                        <ListItemText>
                            Fermez Safari et redémarrez le
                        </ListItemText>
                    </List>
                    <Box mt={5}>
                        <Link href={"https://support.apple.com/fr-fr/guide/iphone/iph1ec277219/ios"} target={"_blank"}>Plus
                            d'aide ici</Link>
                    </Box>
                </Box>
            </Box>
        );
    }

    return children;
}